import { render, staticRenderFns } from "./CompetitionAdminPage.vue?vue&type=template&id=65be8bd4&scoped=true"
import script from "./CompetitionAdminPage.vue?vue&type=script&lang=js"
export * from "./CompetitionAdminPage.vue?vue&type=script&lang=js"
import style0 from "./CompetitionAdminPage.vue?vue&type=style&index=0&id=65be8bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be8bd4",
  null
  
)

export default component.exports